import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Send from '@material-ui/icons/Send';
import ResendMailDialog from '../molecules/ResendMailDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openResendMail', 'updateOpenResendMail', false)
);

const button = enhance(
  ({
    classes,
    openResendMail,
    updateOpenResendMail,
    params,
    onClickAction
  }) => {
    const cancelAction = () => updateOpenResendMail(false);
    const resendMailAction = param => {
      updateOpenResendMail(false);
      onClickAction(param);
    };
    return (
      <div>
        <Button color="primary" onClick={() => updateOpenResendMail(true)}>
          <Send className={classes.leftIcon} />
          メール再送信
        </Button>
        <ResendMailDialog
          openResendMail={openResendMail}
          updateOpenResendMail={updateOpenResendMail}
          cancelAction={cancelAction}
          resendMailAction={() => resendMailAction(params)}
          target="メニュー"
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
